import { store } from "@risingstack/react-easy-state";

export const ProductStore = store({
  isMassApproval: false,
  productDetails: null,
  setMassApproval: (val: boolean) => (ProductStore.isMassApproval = val),
  setProductDetails: (product: any) => (ProductStore.productDetails = product),
});
